import requestor from "../../requestor";
import CourseApi from "./course/course.api";

export default class AdminApi {
  common = () => requestor.get("/manage/common");
  changeModelModerationStatus = (modelTypeId, modelId, statusId, reason) =>
    requestor.patch("/manage/change-model-moderation-status", {
      model_type_id: modelTypeId,
      model_id: modelId,
      status_id: statusId,
      reason: reason
    });

  user = {
    all: (page, user_id = null) =>
      requestor.get("/manage/user_all", {
        page: page,
        filter: {
          user_id: user_id,
        },
      }),
    one: (id) => requestor.get("/manage/user_one", { id: id }),
    save: (form) => requestor.post("/manage/user_save", { User: form }),
    ban: (id) => requestor.put("/manage/user_ban", { id: id }),
    changePassword: (userId, newPassword, repeatNewPassword) =>
      requestor.put("/manage/user_change_password", {
        user_id: userId,
        Password: {
          new_password: newPassword,
          repeat_new_password: repeatNewPassword,
        },
      }),
  };
  consultation = {
    all: (page) => requestor.get("/manage/consultation_all", { page: page })
  };

  payout = {
    all: (page = 1) => requestor.get("/admin/payout_request_all", { page: page }),
    one: (id) => requestor.get("/admin/payout_request_one", { id: id }),
    approve: (form) => requestor.put("/admin/payout_request_approve", form),
    cancel: (id) => requestor.get("/admin/payout_request_cancel", { id }),
    fee: (receiver_service_instance_id, amount) =>
      requestor.get("/admin/payout_request_fee", {
        receiver_service_instance_id: receiver_service_instance_id,
        amount: amount,
      }),
    moderateReceipt: (id) => requestor.get("/admin/payout_request_receipt_moderate", { id }),
  };
  invoice = {
    all: (page = 1, filter = {}) => requestor.get("/admin/invoice_all", { page: page, filter: filter }),
    handlePaid: (invoiceId, receiverServiceInstanceId, paymentTypeId, paymentFee, useCashier) =>
      requestor.put("/admin/invoice_handle_paid", {
        id: invoiceId,
        receiver_service_instance_id: receiverServiceInstanceId,
        payment_type_id: paymentTypeId,
        payment_fee: paymentFee,
        use_cashier: useCashier,
      }),
    accountingReport: (date_from, date_to) =>
      requestor.get("/admin/invoice_accounting-report", {
        date_from, date_to
      }),
  };
  item = {
    autocomplete: (query, page = 1, limit = 10) => requestor.get("/manage/item_autocomplete", { query: query, page: page, limit: limit }),
    one: (id) => requestor.get("/manage/item_one", { id: id }),
    all: (page = 1, filter = {}) => requestor.get("/manage/item_all", { page: page, filter: filter }),
    save: (form) => requestor.patch("/manage/item_save", { Item: form }),
  };
  get course() {
    if (!this._courseApi) {
      this._courseApi = new CourseApi(true);
    }
    return this._courseApi;
  }
}
